import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

const featuredComics = comics.filter((c) => c.featured);

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20fantasy%20and%20romance%20characters%20in%20dramatic%20composition%2C%20warm%20amber%20and%20coral%20color%20palette%2C%20artistic%20digital%20painting%20with%20soft%20gradients%2C%20modern%20manga%20aesthetic%2C%20elegant%20atmospheric%20background%20with%20subtle%20texture&width=1600&height=900&seq=hero-bg-001&orientation=landscape"
          alt="韩漫网 - 高清韩国漫画大全"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4 w-full max-w-4xl mx-auto">
        <h1 className="text-3xl md:text-5xl font-heading font-bold text-white mb-4 leading-tight">
          免费在线韩国漫画阅读平台
        </h1>
        <p className="text-base md:text-lg text-white/80 mb-8 max-w-2xl">
          高清韩国漫画大全，资源齐全，界面简洁，每日更新热门韩漫，随时随地畅享阅读乐趣。
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/all"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            开始阅读
          </Link>
          <Link
            to="/about"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="px-8 py-3 rounded-full border border-white/30 text-white font-medium text-sm hover:bg-white/10 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>

      <div className="absolute bottom-8 left-0 right-0 z-10 hidden md:block">
        <div className="max-w-5xl mx-auto px-6">
          <div className="grid grid-cols-5 gap-3">
            {featuredComics.slice(0, 5).map((comic) => (
              <Link
                key={comic.id}
                to={`/comic/${comic.slug}`}
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                className="group cursor-pointer"
              >
                <div className="relative overflow-hidden rounded-lg aspect-[3/4]">
                  <img
                    src={comic.cover}
                    alt={comic.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300"></div>
                </div>
                <p className="text-xs text-white/80 mt-1.5 text-center truncate group-hover:text-white transition-colors">
                  {comic.title}
                </p>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}